exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-body[data-v-6e3a2ece]{background:#f0f0f0;max-width:100%;min-height:100vh}.filter-btn[data-v-6e3a2ece]{color:#fff}.filter-label[data-v-6e3a2ece]{font-size:18px;color:#333}", ""]);

// exports
